export default __webpack_public_path__ + "static/media/house.73123dd3.png";